import { es } from '@/assets/translations'

export const handleSetCountryCode = (countryCode) => {
  for (const country in es) {
    if (country === countryCode) {
      return es[country]['PRE_MOBILE']
    }
  }
}
